import {
  FetchSalaryCardFailureAction,
  FetchSalaryCardRequestAction,
  FetchSalaryCardSuccessAction,
  SalaryCardActions,
  SalaryCardActionTypes,
  SalaryCardType,
} from 'store/types/salaryCard'
import { Dispatch } from 'redux'
import { getAllUsersList } from '../../../services/SalaryCards/AllUsers'

export const fetchSalaryCardRequest = (): FetchSalaryCardRequestAction => ({
  type: SalaryCardActionTypes.FETCH_SALARY_CARD_REQUEST,
})

export const fetchSalaryCardSuccess = (
  salaryCardList: SalaryCardType[]
): FetchSalaryCardSuccessAction => ({
  type: SalaryCardActionTypes.FETCH_SALARY_CARD_SUCCESS,
  payload: salaryCardList,
})

export const fetchSalaryCardFailure = (
  error
): FetchSalaryCardFailureAction => ({
  type: SalaryCardActionTypes.FETCH_SALARY_CARD_FAILURE,
  payload: error,
})

export const fetchSalaryCards = (value: any) => {
  return async (dispatch: Dispatch<SalaryCardActions>) => {
    dispatch(fetchSalaryCardRequest())

    try {
      const data = await getAllUsersList(value)

      dispatch(fetchSalaryCardSuccess(data))
    } catch (error) {
      dispatch(fetchSalaryCardFailure(error.message))
    }
  }
}

